var map = {
	"./avatar_01.jpg": 2830,
	"./avatar_02.jpg": 5321,
	"./avatar_03.jpg": 1596,
	"./avatar_04.jpg": 5383,
	"./kv.webp": 6155,
	"./pic1_01.jpg": 7580,
	"./pic2_01.jpg": 153,
	"./pic2_02.jpg": 7662,
	"./pic2_03.jpg": 475,
	"./pic2_04.jpg": 7640,
	"./sect3SeniorityFlag.png": 3663,
	"./sectBack2.png": 2991,
	"./sectBack3.png": 4246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9885;